
const langDisplay = new Intl.DisplayNames(['en'], { type: 'language' });

// Fallback names for codes Intl.DisplayNames doesn't resolve in some browsers.
const LANGUAGE_NAME_OVERRIDES: Record<string, string> = {
    iu: 'Inuktitut',
    wuu: 'Wu Chinese',
    yue: 'Cantonese',
    cmn: 'Chinese',
    arb: 'Arabic',
    fil: 'Filipino',
};

export function languageNameFromCode(code?: string | null): string {
    if (!code) return '';
    const prefix = code.split('-')[0].toLowerCase();
    if (LANGUAGE_NAME_OVERRIDES[prefix]) return LANGUAGE_NAME_OVERRIDES[prefix];
    try { return langDisplay.of(prefix) || code; } catch { return code; }
}
